const EncryptedStrings = {
  secretKeyAes: '4x4HdmYOxvGEjJ6jjDwAqQ==',
  secretkeyHash: 'Cashe_Test_Hash_Key',
  QA_secretKeyAes: '4x4HdmYOxvGEjJ6jjDwAqQ==',
  PROD_secretKeyAes: 'X/1fo42f/Q2hfZDMHMGybA==',
  QA_Key_Aes: 'collections_test',
  socket_Enc_Key: 'dIaIhIUchaojwqXD',
  ClientID: "338124111297-6f489k7omf0bpv4sn3q0v1bvikl24oi4.apps.googleusercontent.com"
};
export default EncryptedStrings;
